import { Subject } from '@angular-devkit/core/node_modules/rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessagePopService {
  public notifySubject = new Subject();

  constructor() {
  }

}

export const MessagePopConstants = {
  SUCCESS: "alert-success",
  FAILURE: "alert-danger",
  INFO: "alert-info",
};

export interface MessagePopConfig {
  subject: string;
  message: string;
  status: string;
  timeDelay?: number;
}